import $ from 'jquery'
import _ from 'lodash'
import template from './metric-approvals.hbs'
import approveRejectAllButtons from './approve-reject-all-buttons.hbs'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import FormView from 'scoreboard/components/form-view'
import appDisplay from 'scoreboard/components/app-display'
import noMetricApprovals from './no-metric-approvals.hbs'
import EmptyState from 'scoreboard/components/empty-state'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import tooltipTemplate from 'scoreboard/scorecards/non-abbreviated-values-tooltip.hbs'
import MetricUpdateFilter from 'scoreboard/home/metric-updates/metric-update-filter'
import Tooltip from 'scoreboard/components/tooltip'
import { ALL_ORGS } from 'scoreboard/home/metric-updates/metric-updates'
import guard from 'scoreboard/components/unsaved/guard'
import center from 'scoreboard/components/min-height-vertical-center-msg.hbs'
import HomeNav from '../home-nav'
import { isV5 } from 'scoreboard/components/version'
import MetricApprovalsPreview from './metric-approvals-preview'
const ALL_CALENDARS = -1
import BaseMetricApprovals from './base-metric-approvals'

const MetricApprovals = BaseMetricApprovals.extend({

	tagName: 'form',

	className: 'home metric-approvals table-hack display-layout scroll-layout-xy',

	events: _.extend({}, BaseMetricApprovals.prototype.events, {
		'click .approve-all-metrics': 'onClickApproveAllMetrics',
		'click .reject-all-metrics': 'onClickRejectAllMetrics',
		'click .approve-metric': 'onClickApproveMetric',
		'click .reject-metric': 'onClickRejectMetric',
		'click .preview': 'onClickPreview',
		'click .filter': '_filter',
	}),

	/**
	 * The "Approve Measures" screen in the home section
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.data the data to display in the table
	 *
	 * @param {Object} options.seriesBySnId metadata about the series for the
	 * metrics mentioned in the preview
	 */
	initialize: function(options) {
		BaseMetricApprovals.prototype.initialize.call(this, options)
		this.unshortenedValueTooltips = []
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			toggleCancel: true
		})
		this.formView.on('cancel', this.cancel.bind(this))
		this.selectedOrgId = ALL_ORGS
		this.selectedCalendarId = ALL_CALENDARS
		// populate the organization information
		this.orgs()
	},

	render: function() {
		this.displayHeader = new DisplayHeader({
			heading: i18n.get('home.metricUpdates'),
			mobileGearHidden: true
		})

		this.$el.empty().append(this.displayHeader.el, template())
		this.displayHeader.render()

		if (_.isEmpty(this.data)) {
			this.emptyState = new EmptyState({
				heading: i18n.get('home.metricApprovals'),
				body: noMetricApprovals()
			})
			appDisplay.display(this.emptyState)
			this.renderHomeNav(this.emptyState.$el)
			return
		}
		// add the approve all/reject all buttons to the table header row
		// (just once, not every time the table is re-rendered)
		this.$('.has-buttons').append(approveRejectAllButtons())
		// render the table body
		this.renderFilteredMetricsTable(this.data)
		this.setupTooltips()

		this.renderHomeNav(this.$('.home-nav-container'))

		this.formView.start()

		this.updatePreviewButton()

		return this
	},

	renderHomeNav: function(container) {
		if (isV5()) {
			return
		}
		this.homeNav = new HomeNav({
			section: 'metric-approvals'
		})
		container.prepend(this.homeNav.el)
		this.homeNav.render()
	},

	renderMetricsTable: function(data) {
		BaseMetricApprovals.prototype.renderMetricsTable.apply(this, arguments)
		// render bottom row only if we have data after filtering
		if (!_.isEmpty(data)) {
			this.renderApproveRejectAllBottomRow()
		}
	},

	/**
	 * Render the table of metric updates needing approvals,
	 * filtered by any filter selections (organization or calendar type)
	 * Default selected org id is ALL_ORGS (-1)
	 * Default selected calendar id is ALL_CALENDARS (-1)
	 */
	renderFilteredMetricsTable(data) {
		let filteredData = this.dataForSelectedCalendar(data, this.selectedCalendarId)
		if (this.selectedOrgId > 0) {
			filteredData = this.dataForSelectedOrg(filteredData, this.selectedOrgId)
			this.renderMetricsTable(filteredData)
		} else {
			this.renderMetricsTable(filteredData)
		}
	},

	/**
	 *  Filters the metric approval data for only the given org id
	 */
	dataForSelectedOrg: function(data, orgId) {
		if (ALL_ORGS == orgId) return data
		return _.filter(data, datum => {
			return datum.organizationId == orgId
		})
	},

	/**
	 *  Filters the metric approval data for only the given calendar id
	 */
	dataForSelectedCalendar: function(data, calendarId) {
		if (ALL_CALENDARS == calendarId) return data
		return _.filter(data, datum => {
			return datum.calendarId == calendarId
		})
	},

	renderApproveRejectAllBottomRow: function() {
		let approveRejectAllBottomRow =
			`<tr class="table-body-subheader approve-all-metrics-row">
				<td colspan="2">
					${i18n.get('home.approveMetrics.approveRejectAllNewValues')}
				</td>
				<td class="button-cell">${approveRejectAllButtons()}</td>
				<td colspan="4"></td>
			</tr>`

		this.$('tbody').append(approveRejectAllBottomRow)
	},

	/**
	 * Appends a row to the table body to display a no results message if there
	 * is no data to view after applying a filter
	 */
	renderNoResultsRow: function() {
		let message = i18n.get('report.designer.noResults')
		let noResultsRow =
			`<tr class="no-results-row"><td colspan="7">${center(message)}</td></tr>`
		this.$('tbody').append(noResultsRow)
	},

	/**
	 * Enable tooltips to display the full value for those that have been abbreviated
	 */
	setupTooltips: function() {
		const elements = this.$('.is-shortened')
		for (let i = 0; i < elements.length; i++) {
			const tooltip = new TooltipAndDetails({
				el: this.el,
				selector: $(elements[i]),
				tooltipOptions: {
					extraClass: 'tooltip-and-details non-abbreviated-tooltip scorecards-overview-values-non-abbreviated-tooltip equation-viewer '
				},
				tooltipContent: (e) => {
					const header = this.$(e.currentTarget).data('label')
					const value = this.$(e.currentTarget).data('unshortenedValue')
					return tooltipTemplate({ value, header })
				}
			})
			this.unshortenedValueTooltips.push(tooltip)
		}
	},

	onClickApproveMetric: function(event) {
		this.reviewMetric(event.target.closest('tr'), true)
		this.updateButtons()
	},

	onClickRejectMetric: function(event) {
		this.reviewMetric(event.target.closest('tr'), false)
		this.updateButtons()
	},

	onClickApproveAllMetrics: function() {
		if (this.allApproved()) {
			// #39104 all rows are already approved so we want to reset them,
			// which is basically the same thing as clicking cancel
			this.formView.cancel()
		} else {
			const rows = this.$('.metric-row')
			_.forEach(rows, tr => this.reviewMetric(tr, true, false))
			this.updateButtons()
		}
	},

	onClickRejectAllMetrics: function(event) {
		if (this.allRejected()) {
			// #39104 all rows are already rejected so we want to reset them,
			// which is basically the same thing as clicking cancel
			this.formView.cancel()
		} else {
			const rows = this.$('.metric-row')
			_.forEach(rows, tr => this.reviewMetric(tr, false, false))
			this.updateButtons()
		}
	},

	/**
	 * Get the list of reviewed metrics (approved or rejected)
	 * @returns {Array} An array of reviewed metric objects
	 */
	getReviewedMetrics() {
		// Filter the data to include only metrics that have been reviewed
		// (i.e., those with an 'approved' property set to either true or false)
		return this.data.filter(m => !_.isNil(m.approved))
	},

	onClickPreview: function() {
		// Use the shared method to get reviewed metrics
		const reviewed = this.getReviewedMetrics()
		const xhr = $.post({
			url: '/api/scorecards/metric-approvals/preview',
			data: JSON.stringify(reviewed),
			error: (xhr) => {
				this.formView.error(xhr)
			}
		})
		appDisplay.dialog(xhr, (data) => {
			return new MetricApprovalsPreview({
				data: data.metrics, // this is data for the calculated metrics
				manualMetrics: this.data,
				numAffectedMetrics: data.numAffectedMetrics,
				numViewableMetrics: data.numViewableMetrics,
				seriesBySnId: data.seriesBySnId
			})
		})
	},

	_findMetricAndIndex: function(metricList, scorecardNodeId, calendarPeriodId, organizationId) {
		let index = -1
		const metric = metricList.find((m, i) => {
			if (m.scorecardNodeId == scorecardNodeId &&
				m.calendarPeriodId == calendarPeriodId &&
				m.organizationId == organizationId) {
				index = i
				return true
			}
			return false
		})
		return { metric, index }
	},

	/**
	 * Set a metric as reviewed (either approved or rejected)
	 *
	 * @param tr the row in the table with the metadata for the metric
	 * @param approve true to approve; false to reject
	 * @param toggle if true, calling this method multiple times with the same "approve"
	 * 				 value will toggle the status of the row; if false, when the
	 * 				 same value is passed in, nothing is changed
	 */
	reviewMetric: function(tr, approve, toggle = true) {
		const scorecardNodeId = $(tr).data('scorecardnodeid')
		const calendarPeriodId = $(tr).data('calendarperiodid')
		const organizationId = $(tr).data('organizationid')

		const metric = this.data.find(m => m.scorecardNodeId == scorecardNodeId &&
				m.calendarPeriodId == calendarPeriodId &&
				m.organizationId == organizationId)

		if (toggle && metric.approved === approve) {
			// If the metric has already been approved/rejected and we attempt to
			// set the same status again, remove the reviewed status. This lets
			// users click the button once to approve/reject, and then click again
			// to undo
			delete metric.approved
		} else {
			// This metric has already been reviewed and the user is switching the
			// state from approved to rejected or vice versa
			metric.approved = approve
		}

		$(tr).toggleClass('reviewed', metric.approved === true || metric.approved === false)
		$(tr).find('.approve-metric').toggleClass('is-selected', metric.approved === true)
		$(tr).find('.reject-metric').toggleClass('is-selected', metric.approved === false)

		this.updatePreviewButton()
	},

	allApproved() {
		return this.$('.approve-metric.is-selected').length === this.$('.metric-row').length
	},

	allRejected() {
		return this.$('.reject-metric.is-selected').length === this.$('.metric-row').length
	},

	/**
	 * Update the states of the approve all/reject all buttons and cancel/save buttons
	 */
	updateButtons() {
		this.$('.approve-all-metrics').toggleClass('is-selected', this.allApproved())
		this.$('.reject-all-metrics').toggleClass('is-selected', this.allRejected())
		if (this.$('.reviewed').length) {
			this.formView.change()
		} else {
			// #39104 all rows have been unselected so disable the save button
			this.formView.cancel()
		}
		this.updatePreviewButton()
	},

	/** Enable the preview if and only if metrics have been approved */
	updatePreviewButton: function() {
		let hasApprovedUpdate = this.data.some(m => m.approved === true)
		this.$('.preview').prop('disabled', !hasApprovedUpdate)
	},

	_filter: function() {
		// Stop if there's nothing to filter
		if (_.isEmpty(this.data)) return

		this.metricApprovalFilter = new MetricUpdateFilter({
			orgs: this.allOrgs,
			orgId: this.selectedOrgId,
			calendarId: this.selectedCalendarId
		})
		this.listenTo(this.metricApprovalFilter, 'change', this._onFilter.bind(this))
		// tooltip
		this.filterTooltip = new Tooltip({
			attachTo: this.$('.filter'),
			content: this.metricApprovalFilter,
			placement: 'below',
			arrow: 'right',
			extraClass: 'filter-tooltip no-max-width'
		}).render()
	},

	_onFilter: function(orgId, calendarId) {
		guard.conditionallyRun(() => {
				// update the selected orgId and calendar id
				this.selectedOrgId = orgId
				this.selectedCalendarId = calendarId
				this._clear()
				this.$('.panel-content').scrollTop(0)
				this.renderFilteredMetricsTable(this.data)
				// after rebuilding the tbody, we need to rebuild the tooltips
				this.setupTooltips()
				// reset the form so the save/cancel buttons are in the right state
				this.formView.start()
			},
			// reopen the filter
			() => this._filter(),
			() => this._filter())

	},

	_clear: function() {
		// maintain width of table while clearing out tbody contents
		this.$('.panel').css('min-width', this.$('.panel').outerWidth())
		this.$('tbody').empty()
		// clear the selected state of the approve all/reject all buttons in the
		// table header (since they aren't removed when re-rendering the tbody)
		this.$('.approve-all-metrics').removeClass('is-selected')
		this.$('.reject-all-metrics').removeClass('is-selected')
	},

	orgs: function() {
		let orgs = this.orgsFromData()
		orgs.unshift({
			label: i18n.get('report.common.optionList.organizations.all'),
			id: ALL_ORGS
		})
		this.allOrgs = orgs
		this.orgsById = _.keyBy(orgs, 'id')
	},

	orgsFromData: function() {
		let orgs =   _(this.data)
			.map(item => {
				return {
					label: item.organizationLabel,
					id: item.organizationId
				}
			})
			.uniqBy('id')
			.sortBy(org => org.label.toLocaleUpperCase())
			.value()
		return orgs
	},

	submit: function() {
		// Use the shared method to get reviewed metrics
		const reviewed = this.getReviewedMetrics()
		return $.post({
			url: '/api/scorecards/metric-approvals',
			data: JSON.stringify(reviewed),
			success: data => {
				// The end point returns any metrics that still haven't been
				// approved
				this.data = data.metrics
				this.seriesBySnId = data.seriesBySnId
				this.render()
			},
			error: (xhr) => {
				this.formView.error(xhr)
			}
		})
	},

	cancel: function() {
		this.$('.reviewed').toggleClass('reviewed', false)
		this.$('.is-selected').toggleClass('is-selected', false)
		this.data.forEach(m => delete m['approved'])
		this.formView.start()
		this.updatePreviewButton()
	},

	remove: function() {
		BaseMetricApprovals.prototype.remove.apply(this, arguments)
		_.invokeMap([this.displayHeader, this.metricApprovalFilter], 'remove')
		_.invokeMap(this.unshortenedValueTooltips, 'remove')
	}
})

export default MetricApprovals
MetricApprovals.__filename__ = 'home/metric-approvals/metric-approvals.js'
